
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { InsuranceTypeOption } from '../models/common-data-types';
import { InsuranceOptionsRequest } from '../models/request-data-types';

@Injectable({
  providedIn: 'root',
})
export class InsuranceTypesService {
  private url = `/selfcare/insurance-types?insuranceClass=MOTOR`;

  constructor(private httpClient: HttpClient) {}
  

  fetchInsuranceTypes(): Observable<InsuranceTypeOption[]> {
    return this.httpClient.get<InsuranceTypeOption[]>(this.url);
  }

  fetchMotorCoverOptions(requestData: InsuranceOptionsRequest): Observable<any> {
    return this.httpClient.post(`/selfcare/motor-cover-options`, requestData);
  }
}
